import { render, staticRenderFns } from "./specialist.vue?vue&type=template&id=07d417d6&scoped=true&"
import script from "./specialist.vue?vue&type=script&lang=js&"
export * from "./specialist.vue?vue&type=script&lang=js&"
import style0 from "./specialist.vue?vue&type=style&index=0&id=07d417d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d417d6",
  null
  
)

export default component.exports